import React, { useState } from "react";
import { tokens } from "../../../theme";
import { MenuItem, SubMenu } from "react-pro-sidebar";
import { Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import FactoryIcon from "@mui/icons-material/Factory";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Venta = () => {
  const [selected, setSelected] = useState("Dashboard");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <>
      <SubMenu
        title="Vidrio"
        icon={<FactoryIcon />}
        style={{ color: colors.grey[300] }}
      >
        <SubMenu
          title="Venta"
          icon={<MonetizationOnIcon />}
          style={{ color: colors.grey[300] }}
        >
          <Item
            title="Pedido de venta"
            to="/registro/pedidoVenta"
            icon={<ReceiptOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Orden de Carga"
            to="/view/ordenCarga"
            icon={<LocalShippingIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Listado de Órdenes"
            to="/view/ordenCargaListado"
            icon={<LocalShippingIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Historial de Ventas"
            to="/view/historialVentas"
            icon={<ReceiptOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
        </SubMenu>
        <SubMenu
          title="Stock"
          icon={<ReceiptOutlinedIcon />}
          style={{ color: colors.grey[300] }}
        >
          <Item
            title="Stock General"
            to="/view/stockview"
            icon={<ReceiptOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Monolitico"
            to="/view/stockMonoliticoVentasview"
            icon={<ReceiptOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Laminado"
            to="/view/stockLaminadoVentaview"
            icon={<ReceiptOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
        </SubMenu>
      </SubMenu>
    </>
  );
};

export default Venta;